// Raw rebrand color primitives — the single source of truth for the brand
// palette shared by the Berlin theme (src/appV2/redesign/theme/rebrand/colors.ts)
// and the legacy MUI theme (src/appV2/lib/Theme/rebrandConstants.ts).
//
// These are intentionally named by hue/role rather than by MUI palette slot, so
// they can be referenced from either theme without implying a slot mapping.
// Semantic tokens (navbar, button, background, etc.) layer on top of these in
// the individual theme files.

// --- Core brand colors ---
export const BRAND_PINK = "#DA2451";
export const BRAND_PINK_DARK = "#862335";
export const BRAND_MAROON = "#37171A";
export const BRAND_TAUPE = "#7B645C";
export const BRAND_DANGER = "#DD3630";
export const BRAND_INK = "#210E10";
export const BRAND_AMBER = "#CE7210";

// --- Neutrals ---
export const BRAND_STONE = "#9F8D7F";
export const BRAND_SAND = "#ECE7DC";

// --- Positive / success ---
export const BRAND_SUCCESS = "#24C23F";

// --- Time-slot "dark" accents (text on light backgrounds) ---
export const TIME_SLOT_AM_DARK = "#F69551";
export const TIME_SLOT_PM_DARK = "#4DBEF5";
export const TIME_SLOT_NOC_DARK = "#A072F7";

// --- Shared alert / chip background tints ---
export const BRAND_PINK_TINT = "#FDE9EA";
export const BRAND_DANGER_TINT = "#FFD9D2";
export const BRAND_WARNING_TINT = "#FBFCE5";
export const BRAND_SUCCESS_TINT = "#D2F2D2";
